<template>
  <div class="container">
    <div class="loading" v-show="loading">
      <Loading />
    </div>
    <section class="table-content" v-show="!loading">
      <div class="table-head">
        <h5>Cuadro 2</h5>
        <h6>Ingresos y Gastos devengados años 2018 - 2019</h6>
      </div>
      <div class="content-table">
        <AlertError v-show="!igDevengados" />
        <TablaAnexo3 v-show="igDevengados" :datos="igDevengados" />
      </div>
      <div class="table-head">
        <h5>Cuadro 3</h5>
        <h6>Análisis del Comportamiento Presupuestario</h6>
      </div>
      <div class="content-table">
        <AlertError v-show="!compPresupuestario" />
        <TablaAnexo3 v-show="compPresupuestario" :datos="compPresupuestario" />
      </div>
      <div class="table-head">
        <h5>Cuadro 6</h5>
        <h6>
          Ejecución de Aspectos Relevantes contenidos en el presupuesto
        </h6>
      </div>
      <div class="content-table">
        <AlertError v-show="!ejecPpto" />
        <TablaAnexo3 v-show="ejecPpto" :datos="ejecPpto" />
      </div>
      <div class="table-head">
        <h5>Cuadro 8</h5>
        <h6>
          Comportamiento Presupuestario de las iniciativas de Inversión
        </h6>
      </div>
      <div class="content-table">
        <AlertError v-show="!inversiones" />
        <TablaAnexo3 v-show="inversiones" :datos="inversiones" />
      </div>
    </section>
  </div>
</template>

<script>
import TablaAnexo3 from "../../../components/tables/TablaAnexo3.vue";
import AlertError from "../../../components/error/AlertError.vue";
import Loading from "../../../components/tools/Loading.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    TablaAnexo3,
    AlertError,
    Loading,
  },
  data() {
    return {
      compPresupuestario: null,
      igDevengados: null,
      ejecPpto: null,
      inversiones: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["year"]),
  },
  methods: {
    requestData: async function() {
      try {
        let idService = this.$route.params.id
        const datosTabla3a = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=13`
        );
        const datosTabla3b = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=3`
        ); // reemplazar 2 por idService
        const datosTabla3e = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=14`
        ); // reemplazar 2 por idService
        const datosTabla3g = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=15`
        );

        const datos3a = datosTabla3a.data[0];
        const datos3b = datosTabla3b.data[0];
        const datos3e = datosTabla3e.data[0];
        const datos3g = datosTabla3g.data[0];

        if (datos3a) {
          this.buildDataTableA(datos3a.datos.modificado["2019"]);
        }
        if (datos3b) {
          this.buildDataTableB(datos3b.datos.modificado["2019"]);
        }
        if (datos3e) {
          this.buildDataTableE(datos3e.datos.modificado["2018"]);
        }
        if (datos3g) {
          this.buildDataTableG(datos3g.datos.modificado["2020"]);
        }
        setTimeout(() => {
          this.loading = false;
        }, 1500);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    buildDataTableA: function(data) {
      const gastos = data.filter((d) => d.subtitulo > 20 && d.subtitulo != 99);
      const ingresos = data.filter((d) => d.subtitulo < 20);
      const resultado = data.find((d) => d.subtitulo == 99);
      let toView = [];

      toView.push({
        denominación: "INGRESOS",
        monto_año_2018: null,
        monto_año_2019: null,
        notas: null,
        _rowVariant: "resaltar",
      });
      ingresos.forEach((i) => {
        toView.push({
          denominación: i.nombre,
          monto_año_2018: new Intl.NumberFormat().format(i.anio2018),
          monto_año_2019: new Intl.NumberFormat().format(i.anio2019),
          notas: "",
        });
      });
      toView.push({
        denominación: "GASTOS",
        monto_año_2018: null,
        monto_año_2019: null,
        notas: null,
        _rowVariant: "resaltar",
      });
      gastos.forEach((i) => {
        toView.push({
          denominación: i.nombre,
          monto_año_2018: new Intl.NumberFormat().format(i.anio2018),
          monto_año_2019: new Intl.NumberFormat().format(i.anio2019),
          notas: "",
        });
      });
      toView.push({
        denominación: resultado.nombre,
        monto_año_2018: new Intl.NumberFormat().format(resultado.anio2018),
        monto_año_2019: new Intl.NumberFormat().format(resultado.anio2019),
        notas: null,
        _rowVariant: "resaltar",
      });

      this.igDevengados = toView;
    },
    buildDataTableB: function(data) {
      const gastos = data.filter((d) => d.subtitulo > 20 && d.subtitulo != 99);
      const ingresos = data.filter((d) => d.subtitulo < 20);
      let toShowData = [];

      toShowData.push({
        subtitulo: "",
        denominación: "INGRESOS",
        presupuesto_inicial: null,
        presupuesto_final: null,
        ingresos_y_gastos_devengados: null,
        diferencia: null,
        _rowVariant: "resaltar",
      });
      ingresos.forEach((i) => {
        toShowData.push({
          subtitulo: i.subtitulo,
          denominación: i.itemNombre,
          presupuesto_inicial: new Intl.NumberFormat().format(i.pptoInicial),
          presupuesto_final: new Intl.NumberFormat().format(i.pptoFinal),
          ingresos_y_gastos_devengados: new Intl.NumberFormat().format(
            i.pptoDevengados
          ),
          diferencia: new Intl.NumberFormat().format(i.diferencia),
        });
      });
      toShowData.push({
        subtitulo: "",
        denominación: "GASTOS",
        presupuesto_inicial: null,
        presupuesto_final: null,
        ingresos_y_gastos_devengados: null,
        diferencia: null,
        _rowVariant: "resaltar",
      });
      gastos.forEach((i) => {
        toShowData.push({
          subtitulo: i.subtitulo,
          denominación: i.itemNombre,
          presupuesto_inicial: new Intl.NumberFormat().format(i.pptoInicial),
          presupuesto_final: new Intl.NumberFormat().format(i.pptoFinal),
          ingresos_y_gastos_devengados: new Intl.NumberFormat().format(
            i.pptoDevengados
          ),
          diferencia: new Intl.NumberFormat().format(i.diferencia),
        });
      });

      this.compPresupuestario = toShowData;
    },
    buildDataTableE: function(data) {
      this.ejecPpto = data.map((i) => ({
        denominación: i.subtituloNombre,
        ley_inicial: new Intl.NumberFormat().format(i.leyInicial),
        presupuesto_final: new Intl.NumberFormat().format(i.pptoFinal),
        devengado: new Intl.NumberFormat().format(i.pptoDevengados),
        observaciones: "",
      }));
    },
    buildDataTableG: function(data) {
      this.inversiones = data.map((i) => ({
        iniciativas_de_inversion: i.iniciativasDeInversion,
        costo_total_estimado: new Intl.NumberFormat().format(
          i.costoTotalEstimado
        ),
        porcentaje_avance_al_año_2019: i.avanceAlAnio2019 + "%",
        presupuesto_final_año_2019: new Intl.NumberFormat().format(
          i.presupuestoFinalAno2019
        ),
        ejecucion_año_2019: new Intl.NumberFormat().format(i.ejecucionAno2019),
        saldo_por_ejecutar: new Intl.NumberFormat().format(i.saldoPorEjecutar),
        notas: "",
      }));
    },
  },
  mounted() {
    this.requestData();
  },
  watch: {
    year: function() {
      this.requestData();
    },
  },
};
</script>
<style>
.table-head {
  background-color: #efefef;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #24c6ab;
  font-weight: 600;
}
.table-content {
  padding: 0 2rem;
}
</style>
